import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { getProductionLineStrippingDataP2 } from "./services";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { Box, TablePagination } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getStrippingStationDetails } from "../ProductionLine/services";

const Stripping = ({ setStrippingPopup, batchId }) => {
  const [strippingData, setStrippingData] = useState([]);

  useEffect(() => {
    handleGetStrippingData();
  }, [batchId]);

  const handleGetStrippingData = async () => {
    try {
      const resp = await getStrippingStationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setStrippingData(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setStrippingData([]);
      console.log("handlesubmit", error);
    }
  };

  return (
    <>
      <div className="modal-container" style={{ height: "40vh", top: "35vh" }}>
        <div className="modal-header">
          <div className="modal-title">STRIPPING PROCESS SHEET</div>
          <div
            onClick={() => setStrippingPopup(false)}
            style={{ cursor: "pointer" }}
          >
            <CloseIcon />
          </div>
        </div>
        <div className="modal-table-wrapper">
          <div
            style={{
              width: "100%",
              overflow: "auto",
              maxHeight: "400px",
            }}
            className="gloves-report-data"
          >
            <Table className="dipping-params">
              <TableHead>
                <TableRow>
                  <TableCell>Batch no.</TableCell>
                  <TableCell>Class</TableCell>
                  <TableCell>Size</TableCell>
                  <TableCell>Cycle Start Time</TableCell>
                  <TableCell>Cycle End Time</TableCell>
                  <TableCell>Operator</TableCell>
                  <TableCell>Supervisor</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="gloves-report-body">
                {strippingData?.map((e) => {
                  return (
                    <TableRow>
                      <TableCell>
                        {e.batch_type ? e.batch_type : "--"}
                      </TableCell>
                      <TableCell>
                        {e.class_name ? e.class_name : "--"}
                      </TableCell>
                      <TableCell>{e.size_name ? e.size_name : "--"}</TableCell>

                      <TableCell>
                        {e
                          ? e?.cycle_start_time
                            ? dayjs(e.cycle_start_time).format("HH:mm:ss")
                            : "--"
                          : "--"}
                      </TableCell>
                      <TableCell>
                        {e
                          ? e?.cycle_end_time
                            ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                            : "--"
                          : "--"}
                      </TableCell>
                      <TableCell>{e.operator ? e.operator : "--"}</TableCell>
                      <TableCell>
                        {e.supervisor ? e.supervisor : "--"}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
      <div
        className="modal-overlay"
        onClick={() => setStrippingPopup(false)}
      ></div>
    </>
  );
};

export default Stripping;
